import { cn } from 'noddi-ui-common';
import { formatPhoneNumber } from 'noddi-util';
import type { MemberGroup } from './notificationGroupTypes';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

type Props = {
  member: MemberGroup;
  translations: NotificationGroupOverviewTranslations;
};

/** Read-only stand-in for the contact inputs; the name is already the sheet title, so only identifiers are listed. */
export const MemberContactSummary = ({ member, translations: t }: Props) => (
  <dl className='flex flex-col gap-2 text-sm'>
    <div className='flex justify-between gap-3'>
      <dt className='text-muted-foreground'>{t.phoneNumber}</dt>
      <dd className='truncate'>{member.phoneNumber ? formatPhoneNumber(member.phoneNumber) : '-'}</dd>
    </div>
    <div className='flex justify-between gap-3'>
      <dt className='text-muted-foreground'>{t.email}</dt>
      <dd className={cn('truncate', !member.email && 'text-muted-foreground')}>{member.email || '–'}</dd>
    </div>
  </dl>
);
